import { EntityIcon } from '@components/core-ui/EntityIcon/';
import Meatballs from '@components/icons/Meatballs.svg';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { MeResponseDto } from 'app/API';
import React from 'react';
import { useNavigate } from 'react-router';
import { TProps } from './types/TProps';

export const WorkspaceList = ({ closeList }: TProps) => {
  const { workspace, organization, setWorkspace } = useAuthContext();

  const navigate = useNavigate();

  const handleWorkspaceClick = (ws: MeResponseDto['organizations'][0]['workspaces'][0]) => {
    setWorkspace(ws);
    navigate(routes.jobsList.make(organization?.slug ?? '', ws.slug));
    closeList();
  };

  const handleWorkspaceDetailsClick = (
    e: React.MouseEvent<SVGSVGElement>,
    ws: MeResponseDto['organizations'][0]['workspaces'][0],
  ) => {
    e.stopPropagation();
    e.preventDefault();
    navigate(routes.workspaceDetails.make(organization?.slug ?? '', ws.slug));
    closeList();
  };

  return (
    <div className="w-full h-auto max-h-52 overflow-y-auto absolute z-30 bg-surface shadow-xl">
      <ul>
        {organization?.workspaces
          ?.filter((ws: MeResponseDto['organizations'][0]['workspaces'][0]) => {
            const userHasManageWorkspacesPermission = organization?.permissions.manageWorkspaces;
            const userTeamsIncludesWorkspaceTeam = ws.Teams.some((wsTeam) =>
              organization?.userTeams.map((userTeam) => userTeam.name).includes(wsTeam.name),
            );

            return ws.id !== workspace?.id && (userTeamsIncludesWorkspaceTeam || userHasManageWorkspacesPermission);
          })
          .map((ws: MeResponseDto['organizations'][0]['workspaces'][0]) => (
            <li
              key={ws.id}
              className="relative cursor-pointer text-foreground-muted text-base hover:bg-surface-muted flex flex-row px-2 group"
            >
              <a
                className="w-full max-w-48 py-2 text-ellipsis overflow-hidden whitespace-nowrap align-middle font-medium flex"
                onClick={() => handleWorkspaceClick(ws)}
                title={ws.name}
              >
                <EntityIcon name={ws.name} onClick={() => handleWorkspaceClick(ws)} />
                <span className="text-ellipsis overflow-hidden w-36 leading-[30px] ml-2">{ws.name}</span>
                <Meatballs
                  className="hidden absolute top-1/2 right-0 h-5 w-5 p-[5px] -mt-[10px] mr-[10px] group-hover:block"
                  onClick={(e) => handleWorkspaceDetailsClick(e, ws)}
                />
              </a>
            </li>
          ))}
      </ul>
    </div>
  );
};
